// extracted by mini-css-extract-plugin
module.exports = {"overlayBox":"overlayBox--3zK3a"};